export default class MobileNav {
  /**
  * Constructs a new MobileNav expander.
  * @param {object} options - Options.
  */
  constructor (options) {
    this.element = options.element
    var acc = this.element.queryAll("li.has-sub-menu > a")
    var panel = this.element.queryAll('li.has-sub-menu .sub-menu-panel')
    for (var i = 0; i < acc.length; i++) {
      acc[i].onclick = function (event) {
        event.preventDefault()
        var setClasses = !this.classList.contains('active')
        setClass(acc, 'active', 'remove')
        setClass(panel, 'active', 'remove')
        if (setClasses) {
          this.classList.toggle("active")
          this.nextElementSibling.classList.toggle("active")
        }
      }
    }
    function setClass(els, className, fnName) {
      for (var i = 0; i < els.length; i++) {
        els[i].classList[fnName](className)
      }
    }
  }
}